import { ConnectorSpec } from '@integration-app/sdk'
import { Heading, Text } from 'ui-kit/typography'
import { toHeaderCase } from 'js-convert-case'
import classes from './IntegrationPageUdmMapping.module.scss'

export function IntegrationPageUdmMapping({
  connector,
  similarConnectors,
}: {
  connector: ConnectorSpec
  similarConnectors: Array<ConnectorSpec>
}) {
  if (!connector) {
    return null
  }

  const udmToConnector: Record<string, Record<string, string>> = {}

  for (const similarConnector of similarConnectors) {
    for (const udm of connector?.udms ?? []) {
      const udmSpec = similarConnector.udm?.[udm]
      if (!udmSpec) continue

      if (!udmToConnector[udm]) {
        udmToConnector[udm] = {}
      }

      const collectionMapping = udmSpec.collectionMappings?.[0]
      if (collectionMapping) {
        // @ts-expect-error TS(2538): Type 'undefined' cannot be used as an index type.
        udmToConnector[udm][similarConnector.key] = toHeaderCase(
          collectionMapping.key,
        )
      }
    }
  }

  const sortedUdms = Object.keys(udmToConnector)
    .sort(
      (a, b) =>
        Object.keys(udmToConnector[b]).length -
        Object.keys(udmToConnector[a]).length,
    )
    .slice(0, 5)

  return (
    <section className={classes.section}>
      <div className={classes.wrapper}>
        <Heading as={'h2'} size={'xl'} center balance className={classes.title}>
          Use the same code to integrate with&nbsp;{connector.name} and 100+
          other applications
        </Heading>
        <Text size={'lg'} center balance className={classes.subtitle}>
          With universal integrations, you can build your integration scenario
          once and it will work with every app automatically.
        </Text>

        <div className={classes.tableWrapper}>
          <table>
            <thead>
              <tr>
                <th className={classes.tableHeader}></th>
                {sortedUdms.map((udm) => (
                  <th key={udm}>
                    <div className={classes.umdTitle}>
                      <h3>{toHeaderCase(udm)}</h3>
                      <p>automatically maps to</p>
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {similarConnectors.map((similarConnector) => (
                <tr key={similarConnector.key}>
                  <th className={classes.tableRowHeader}>
                    <div className={classes.connectorTitle}>
                      <ConnectorLogo connector={similarConnector} />{' '}
                      {similarConnector.name}
                    </div>
                  </th>
                  {sortedUdms.map((udm) => (
                    <td key={udm}>
                      <div className={classes.connectorUmdTitle}>
                        <ConnectorLogo connector={similarConnector} />
                        {/*// @ts-expect-error TS(2538): Type 'undefined' cannot be used as an index type.*/}
                        {udmToConnector[udm][similarConnector.key] || '—'}
                      </div>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <th className={classes.tableFooter}></th>
                {sortedUdms.map((udm) => (
                  <th key={udm}>
                    <div className={classes.umdTitleFooter} />
                  </th>
                ))}
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </section>
  )
}

function ConnectorLogo({ connector }: { connector: ConnectorSpec }) {
  return (
    <span className={classes.connectorLogo}>
      <img
        src={connector.logoUri}
        alt={connector.name}
        className={classes.connectorLogo_image}
        width={28}
        height={28}
        loading='lazy'
      />
    </span>
  )
}
